module.exports = __webpack_public_path__ + "officialStatic/img/news19.13f64c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/news19.jpg
// module id = 2zl2
// module chunks = 0